import React, { useEffect, useState } from "react";
import useWebSocket, { ReadyState } from "react-use-websocket";
import { useStoreon } from "storeon/react";
import { v4 as uuidv4 } from "uuid";
import styles from "./styles.module.scss";
import spareImg from "../../../shared/images/spare.svg";
import { ADD_PLAYER, GAME_CHANGE_PLAYER } from "../../../store/players";
import {
  SET_LAST_PLAYER_UPDATED,
  ADD_TIMER_HIDE_SCORECARD,
} from "../../../store/timersScoreCards";
import LastFrame from "../tablesByLane/lastFrame/lastFrame";

const CardByLane = (props) => {
  const { bowlingCenterInput, playersPreview, cardStyles } = props;
  const socketUrl = process.env.REACT_APP_WEBSOCKET_URL;
  const apiKey = process.env.REACT_APP_API_KEY;

  const { sendMessage, lastMessage, readyState } = useWebSocket(socketUrl, {
    onOpen: () => console.log("opened"),
    onClose: () => console.log("closed"),
  });

  const {
    dispatch,
    players,
    generalSettings,
    timersScoreCards,
    loggedInUserProfile,
  } = useStoreon(
    "players",
    "generalSettings",
    "timersScoreCards",
    "loggedInUserProfile"
  );
  const { accountType } = loggedInUserProfile;
  const loggedInUser = localStorage.getItem("loggedInUser");
  const loggedInUserObj = loggedInUser && JSON.parse(loggedInUser);
  const { lastPlayerUpdated } = timersScoreCards;
  const [playersByLane, setPlayersByLane] = useState([]);
  const [squares] = useState(new Array(12).fill(""));
  const [game, setGame] = useState(null);

  useEffect(() => {
    if (!playersByLane.length) {
      setGame(1);
    }
  }, [playersByLane]);

  useEffect(() => {
    // when WS connection is established, send the connect request message (method: 0)
    if (readyState === ReadyState.OPEN) {
      sendMessage(
        JSON.stringify({
          id: uuidv4(),
          method: 0,
          params: {
            api_key: apiKey,
          },
        })
      );
    }
  }, [readyState]);

  useEffect(() => {
    if (lastPlayerUpdated) {
      dispatch(ADD_TIMER_HIDE_SCORECARD, {
        bowlingCenterUUID: lastPlayerUpdated.bowlingCenterUuid,
        lane: lastPlayerUpdated.lane,
      });
    }
  }, [lastPlayerUpdated]);

  useEffect(() => {
    if (bowlingCenterInput && bowlingCenterInput.uuid) {
      if (readyState === ReadyState.OPEN) {
        sendMessage(
          JSON.stringify({
            id: uuidv4(),
            method: 1,
            params: {
              channel: `LiveScores:${bowlingCenterInput.uuid}`,
            },
          })
        );
      }
    }
  }, [bowlingCenterInput, readyState, sendMessage]);

  useEffect(() => {
    if (lastMessage && lastMessage.data) {
      const parsedData = JSON.parse(lastMessage.data);

      const result1 =
        parsedData &&
        parsedData.result &&
        parsedData.result.publications &&
        parsedData.result.publications
          .filter((pub) => pub.data && pub.type === 2 && pub.data.lanes)
          ?.map((x) => x.data.lanes)
          ?.reduce((acc, lanes) => lanes.forEach((lane) => acc.push(lane)))
          ?.filter((e) => e.lane === +bowlingCenterInput.lane);
      const result2 =
        parsedData.result &&
        parsedData.result.data &&
        parsedData.result.data.lane === +bowlingCenterInput.lane &&
        parsedData.result.data;

      if (result2) {
        if (result2.game !== game) {
          dispatch(GAME_CHANGE_PLAYER, result2);
          setGame(result2.game);
        }
        dispatch(ADD_PLAYER, {
          ...result2,
          bowlingCenterUuid: bowlingCenterInput.uuid,
        });
        dispatch(SET_LAST_PLAYER_UPDATED, { player: { ...result2 } });
      } else if (result1) {
        setPlayersByLane(result1);
        setGame(result1.length && result1[0].game);
        result1.forEach((e) => {
          dispatch(ADD_PLAYER, {
            ...e,
            bowlingCenterUuid: bowlingCenterInput.uuid,
          });
        });
      }
    }
  }, [lastMessage, bowlingCenterInput, dispatch]);

  useEffect(() => {
    if (players && players.length) {
      setPlayersByLane(
        players.filter(
          (e) =>
            +e.lane === +bowlingCenterInput?.lane &&
            e.bowlingCenterUuid === bowlingCenterInput.uuid
        )
      );
    }

    if (players && players.length === 0) {
      setPlayersByLane(
        players.filter(
          (e) =>
            +e.lane === +bowlingCenterInput?.lane &&
            e.bowlingCenterUuid === bowlingCenterInput.uuid
        )
      );
    }
  }, [players, bowlingCenterInput]);

  const isSplit = (pin) => {
    return Math.floor(pin / 1024) === 1;
  };

  const calculateCurrentSquare = (laneThrow) => {
    return (
      (laneThrow.throws &&
        Math.round(
          (((laneThrow.throws && laneThrow.throws.length) || 0) + 1) / 2
        )) ||
      1
    );
  };
  const arr =
    playersByLane && playersByLane.length ? playersByLane : playersPreview;

  const {
    fontColor: throwsColor,
    fontSize: throwsFontSize,
    fontBold: throwsFontWeight,
  } = cardStyles.throwsStyle;

  const {
    fontColor: nameColor,
    fontSize: nameFontSize,
    fontBold: nameFontWeight,
    fontFamily: nameFontFamily,
  } = cardStyles.playerName;

  const {
    fontColor: scoreColor,
    fontSize: scoreFontSize,
    fontBold: scoreFontWeight,
  } = cardStyles.frameScore;

  const {
    lowFrameBackground: currentLowFrameBackground,
    topFrameBackground: currentTopFrameBackground,
  } = cardStyles.currentFrame;

  const someStyle = {
    "--throwsColor": throwsColor,
    "--throwsFontSize": throwsFontSize,
    "--throwsFontWeight": throwsFontWeight
      ? "700"
      : loggedInUserObj.accountType === "Freemium"
      ? "400"
      : "normal",
    "--nameColor": nameColor,
    "--nameFontSize": nameFontSize,
    "--nameFontWeight": nameFontWeight
      ? "700"
      : loggedInUserObj.accountType === "Freemium"
      ? "400"
      : "normal",
    "--nameFontFamily": nameFontFamily,
    "--scoreColor": scoreColor,
    "--scoreFontSize": scoreFontSize,
    "--scoreFontWeight": scoreFontWeight
      ? "700"
      : loggedInUserObj.accountType === "Freemium"
      ? "400"
      : "normal",
    "--currentLowFrameBackground": currentLowFrameBackground,
    "--currentTopFrameBackground": currentTopFrameBackground,
    "--topFrameBackground": cardStyles.topFrameBackground,
    "--scoresContainerBackground": cardStyles.scoresContainerBackground,
    "--framesContainerBackground": cardStyles.framesContainerBackground,
    "--sectionContainerBackground": cardStyles.sectionContainerBackground,
    "--fontFamily":
      loggedInUserObj.accountType === "Freemium"
        ? "Roboto Mono"
        : "'Saira', sans-serif",
    "--turnFontWeight": "600",
  };

  return arr && arr.length ? (
    <div className={styles.cardsByLane}>
      {generalSettings.ten_frames_scorecard && (
        <div className={styles.playersCard}>
          <div className={styles.headerCard} style={someStyle}>
            <span>{`Game #${game}`}</span>
            {accountType === "Freemium" && (
              <span
                style={{
                  fontFamily: '"From the Stars Italic", sans-serif',
                  fontSize: "16px",
                }}
              >
                Lanetalk
              </span>
            )}
            <span>{`Lane ${bowlingCenterInput?.lane || 0}`}</span>
          </div>
          <div className={styles.bodyTable}>
            <div className={styles.turns} style={someStyle}>
              {squares.slice(0, 10).map((e, index) => (
                <span className={styles.turn} key={index}>
                  {index + 1}
                </span>
              ))}
            </div>
            {arr
              .slice(0, bowlingCenterInput?.playerNumber || playersPreview.length)
              .map((laneThrow) => {
                return (
                  <div className={styles.players} key={laneThrow.playerNumber}>
                    <div className={styles.squares} style={someStyle}>
                      <span className={styles.playerName}>
                        {laneThrow.playerName}
                      </span>
                      {squares.map((e, index) => (
                        <React.Fragment key={index}>
                          {index < 9 && (
                            <span
                              className={`${styles.square} ${
                                laneThrow.throws &&
                                laneThrow.throws.length > index * 2 &&
                                styles.past
                              } ${
                                (index + 1 ===
                                  calculateCurrentSquare(laneThrow) ||
                                  (index > 9 &&
                                    calculateCurrentSquare(laneThrow) > 9)) &&
                                styles.current
                              }`}
                              key={index}
                            >
                              {(laneThrow.throws &&
                                laneThrow.throws.length &&
                                laneThrow.throws[index * 2] &&
                                laneThrow.throws[index * 2] !== "X" &&
                                index < 9 && (
                                  <span className={styles.numbers}>
                                    <span
                                      className={`${styles.number} ${
                                        isSplit(laneThrow.pins[index * 2]) &&
                                        styles.split
                                      }`}
                                    >
                                      {laneThrow.throws[index * 2]}
                                    </span>
                                    {laneThrow.throws[index * 2 + 1] !==
                                      "/" && (
                                      <span
                                        className={`${styles.number} ${
                                          isSplit(
                                            laneThrow.pins[index * 2 + 1]
                                          ) && styles.split
                                        }`}
                                      >
                                        {laneThrow.throws[index * 2 + 1]}
                                      </span>
                                    )}
                                    {laneThrow.throws[index * 2 + 1] ===
                                      "/" && (
                                      <span className={styles.number}>
                                        <img src={spareImg} alt="" />
                                      </span>
                                    )}
                                  </span>
                                )) ||
                                ""}
                              {(index > 8 && (
                                <div>
                                  {laneThrow.throws &&
                                    laneThrow.throws[index * 2] !== "/" &&
                                    laneThrow.throws[index * 2] !== "X" && (
                                      <span
                                        className={`${styles.number} ${
                                          isSplit(laneThrow.pins[index * 2]) &&
                                          styles.split
                                        }`}
                                      >
                                        {laneThrow.throws[index * 2]}
                                      </span>
                                    )}
                                  {laneThrow.throws &&
                                    laneThrow.throws[index * 2] === "/" &&
                                    laneThrow.throws[index * 2] !== "X" && (
                                      <span className={`${styles.number}`}>
                                        <img src={spareImg} alt="" />
                                      </span>
                                    )}
                                </div>
                              )) ||
                                ""}
                              {(laneThrow.throws &&
                                laneThrow.throws.length &&
                                laneThrow.throws[index * 2] &&
                                laneThrow.throws[index * 2] === "X" && (
                                  <span
                                    className={styles.strike}
                                    style={{
                                      fontFamily:
                                        accountType === "Freemium"
                                          ? "Roboto Mono"
                                          : "inherit",
                                    }}
                                  >
                                    X
                                  </span>
                                )) ||
                                ""}
                              {(index < 9 &&
                                laneThrow.throws &&
                                (!laneThrow.throws.length ||
                                  !laneThrow.throws[index * 2]) && (
                                  <span className={styles.numbers}>
                                    <span className={styles.number}></span>
                                    <span className={styles.number}></span>
                                  </span>
                                )) ||
                                ""}
                              {(index > 8 &&
                                laneThrow.throws &&
                                (!laneThrow.throws.length ||
                                  !laneThrow.throws[index * 2]) && (
                                  <span className={styles.numbers}>
                                    <span
                                      className={`${styles.number} ${
                                        isSplit(laneThrow.pins[index * 2]) &&
                                        styles.split
                                      } ${index > 9 && styles.lastChild}`}
                                    ></span>
                                  </span>
                                )) ||
                                ""}
                            </span>
                          )}
                          {index >= 9 && true && (
                            <span
                              className={`${styles.square} ${
                                laneThrow.throws &&
                                laneThrow.throws.length > index * 2 &&
                                styles.past
                              } ${
                                (index + 1 ===
                                  calculateCurrentSquare(laneThrow) ||
                                  (index > 9 &&
                                    calculateCurrentSquare(laneThrow) > 9)) &&
                                styles.current
                              }`}
                              key={index}
                            >
                              {(index > 8 && (
                                <div>
                                  {laneThrow.throws &&
                                    laneThrow.throws[index + 9] !== "/" &&
                                    laneThrow.throws[index + 9] !== "X" && (
                                      <span
                                        className={`${styles.number} ${
                                          isSplit(laneThrow.pins[index + 9]) &&
                                          styles.split
                                        }`}
                                      >
                                        {laneThrow.throws[index + 9]}
                                      </span>
                                    )}
                                  {laneThrow.throws &&
                                    laneThrow.throws[index + 9] === "/" &&
                                    laneThrow.throws[index + 9] !== "X" && (
                                      <span className={`${styles.number}`}>
                                        <img src={spareImg} alt="" />
                                      </span>
                                    )}
                                </div>
                              )) ||
                                ""}
                              {(laneThrow.throws &&
                                laneThrow.throws.length &&
                                laneThrow.throws[index + 9] &&
                                laneThrow.throws[index + 9] === "X" && (
                                  <span
                                    className={styles.strike}
                                    style={{
                                      fontFamily:
                                        accountType === "Freemium"
                                          ? "Roboto Mono"
                                          : "inherit",
                                    }}
                                  >
                                    X
                                  </span>
                                )) ||
                                ""}
                              {(index > 8 &&
                                laneThrow.throws &&
                                (!laneThrow.throws.length ||
                                  !laneThrow.throws[index + 9]) && (
                                  <span className={styles.numbers}>
                                    <span
                                      className={`${styles.number} ${
                                        isSplit(laneThrow.pins[index + 9]) &&
                                        styles.split
                                      } ${index >= 9 && styles.lastChild}`}
                                    ></span>
                                  </span>
                                )) ||
                                ""}
                            </span>
                          )}
                        </React.Fragment>
                      ))}
                    </div>

                    <div className={styles.squares} style={someStyle}>
                      <span className={styles.playerName}></span>
                      {squares.slice(0, 10).map((e, index) => {
                        return (
                          <span
                            className={`${styles.square} ${styles.score} ${
                              laneThrow &&
                              laneThrow.throws.length > index * 2 &&
                              styles.past
                            } ${
                              (index ===
                                calculateCurrentSquare(laneThrow) - 1 ||
                                (calculateCurrentSquare(laneThrow) > 9 &&
                                  index === 9)) &&
                              styles.current
                            }`}
                            key={index}
                          >
                            <span className={styles.numbers}>
                              <span className={styles.scoreNumber}>
                                {(laneThrow && laneThrow.scores[index]) || ""}
                              </span>
                            </span>
                          </span>
                        );
                      })}
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      )}
      {generalSettings.compact_scorecard && (
        <LastFrame
          players={playersByLane.slice(
            0,
            bowlingCenterInput?.playerNumber || playersPreview.length,
          )}
          cardStyles={cardStyles}
        />
      )}
    </div>
  ) : null;
};
export default CardByLane;
